import { useMemo } from 'react'
import { ImageOff } from 'lucide-react'
import { cn } from '../../lib/utils'
import { parsePhotoUrls } from '../../lib/format'

export function IncidentImages({ raw, className, onOpen }: {
  raw?: string | null
  className?: string
  onOpen?: (url: string) => void
}) {
  const urls = useMemo(() => parsePhotoUrls(raw), [raw])
  if (urls.length === 0) {
    return (
      <div className={cn('flex h-32 items-center justify-center gap-2 rounded-lg bg-foreground/[.04] text-xs text-muted-foreground/50', className)}>
        <ImageOff size={16} /> 无现场照片
      </div>
    )
  }
  return (
    <div className={cn('grid grid-cols-3 gap-1.5', className)}>
      {urls.slice(0, 6).map((url) => (
        <button
          key={url}
          type="button"
          onClick={() => onOpen?.(url)}
          className="group relative aspect-[4/3] overflow-hidden rounded-md border border-border bg-black/30"
        >
          <img
            src={`/uploads/incidents/${url.replace(/^.*\//, '')}`}
            alt="现场照片"
            loading="lazy"
            className="size-full object-cover transition group-hover:scale-105"
          />
        </button>
      ))}
    </div>
  )
}
